import { Card, CardContent, Grid, Typography, WithStyles, withStyles } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MyPATTextArea, MyPATTextField } from '../../../common';

import { FAQ as FAQInterface, QuestionAnswer } from '../../types/interfaces/AdvancedSettings';

import {
	Delete as DeleteIcon,
} from "@material-ui/icons";

import * as XLSX from 'xlsx'; 

import { courseStyles } from "../../styles";
import { TabVisited } from '../../types/interfaces/TabVisited';
import UploadFAQPopUp from "../coursePlan/addTestDialog/uploadFAQPopUp";
import { bindActionCreators } from 'redux';
import { showMsg } from '../../../course/actions/loaderAlert';
import _ from 'lodash';
interface Props extends WithStyles<typeof courseStyles> {
  faq: FAQInterface;
  handleFAQ: (FAQ: FAQInterface) => void;
  checkFormErrors: (formErrors: any) => void;
  isPreview: boolean;
  disableFields:boolean;
  tabVisited: TabVisited;
  setTabVisited: Function;
  isPublishBtnClicked: boolean;
  showMessage: Function;
}

interface State {
  // faq: FAQInterface;
  formErrors: any;
  open: boolean;
}

interface RawData {
  Answer: string,
  Question: string,
  "Sequence No.": string
}

class FAQ extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // const { deafultValues } = props;
    // this.state = {
    //   faq: deafultValues
    // };
    this.state = {
      formErrors: {
        FAQ: [],
        AnswerErrors: [],
      },
      open: false
    }
  }

  toggleUploadDialog = () => {
    console.log('In Toggle Upload Dialog')
    this.setState({
      open: !this.state.open
    })
  }

  componentDidMount(){
    console.log('::::::FAQ - isPreview:::::', this.props.isPreview)
    this.props.setTabVisited('faq')
    this.setState({
      formErrors:  {
        FAQ: [],
        AnswerErrors: [],
      }
    })
  }

  updateFAQQuestion = (event: any, index: number) => {
    const { value } = event.target;
    const { faq , faq : { FAQ = []}} = this.props;
    
    // let { FAQToUpdate, FAQIndex } = this.getFAQObjectAndIndex(FAQ, sequence);
    let newFAQ = [...FAQ];
    let FAQToUpdate = {...newFAQ[index]};
    
    FAQToUpdate.question = value;
    newFAQ[index] = FAQToUpdate;
    
    let newFaq = {...faq};

    newFaq.FAQ = newFAQ;
   
    this.props.handleFAQ(newFaq)
    const errorText = this.handleValidation('question', value);
    this.updateFormErrors('question', errorText, index)
    // this.setState({
    //   faq: newFaq
    // }, () => console.log(this.state.faq))

  }

  updateFAQAnswer = (event: any, index: number) => {
    const { value } = event.target;
    const { faq, faq : { FAQ = [] }} = this.props;
    let updatedFaq = {...faq};
    let updatedFAQ = [...FAQ];

    // let { FAQToUpdate, FAQIndex } = this.getFAQObjectAndIndex(FAQ, sequence);
    let FAQToUpdate = {...updatedFAQ[index]};

    FAQToUpdate.answer = value;
    updatedFAQ[index] = FAQToUpdate;

    updatedFaq.FAQ = updatedFAQ;

    this.props.handleFAQ(updatedFaq)

    const errorText = this.handleValidation('answer', value)
    this.updateFormErrors('answer', errorText, index)
    // this.setState({
    //   faq: faq
    // }, () => console.log(this.state.faq))
  }

  handleValidation = (type: string, data:string) => {
    switch(type){
      case 'question':
        if(data.length === 0) return 'Question length cannot be 0'
      case 'answer':
        if(data.length === 0) return 'Answer length cannot be 0'
      default:
        return ''
    }
  }

  updateFormErrors = (type:string, errorText: string, index: number) => {
    const { formErrors } = this.state;
    let updatedFormErrors = {...formErrors};
    switch(type){
      case 'question':
        let updatedFAQ = [...updatedFormErrors.FAQ]
        updatedFAQ[index] = errorText
        updatedFormErrors.FAQ = updatedFAQ
        break;
      case 'answer':
        let updatedAnsErrors = [...updatedFormErrors.AnswerErrors]
        updatedAnsErrors[index] = errorText
        updatedFormErrors.AnswerErrors = updatedAnsErrors
        break;
      default:
    }
    this.setState({
      formErrors: updatedFormErrors
    })
    this.props.checkFormErrors(updatedFormErrors)
  }

  renderCard = (questionAnswer: QuestionAnswer, index: number) => {
    const { classes,disableFields, isPreview, isPublishBtnClicked } = this.props;
    const { formErrors } = this.state
    const {
      FAQ,
      AnswerErrors
    } = formErrors;
    console.log({disableFields,isPreview})
    return (
    <>
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <Card className={classes.mb18}>
            <CardContent>
                <Grid container xs={12}>
                    <Grid item xs={12} className={classes.posRelative}>
                        <Typography className={[classes.labelTxt, classes.mb8].join(' ')}>
                            Question {index + 1}
                        </Typography>
                        {
                          isPreview && this.props.faq.FAQ.length > 1 ?(
                            <span className={[classes.DeleteCTA, classes.DeleteFAQ].join(' ')}>
                            {/* <DeleteIcon /> */}
                          </span>
                          ):(
                            (this.props.faq.FAQ.length > 1  && index !== 0) &&
                            <span onClick={() => this.handleRemoveFAQ(`${index}`)} className={[classes.DeleteCTA, classes.DeleteFAQ].join(' ')}>
                            {/* <DeleteIcon /> */}
                            <img src="/assets/svg/myLibrary/delete-outline.svg"/>
                            </span>
                          )
                        }
                       
                    </Grid>
                    <Grid item xs={12}  className={classes.customTextArea}>
                        <MyPATTextArea
                              // className={classes.test}
                            multiline
                            fullWidthControl
                            // inputId="name"
                            name="name"
                            placeholder="Enter Question"
                           disabled={disableFields || isPreview}
                            value={this.props.faq.FAQ[index].question}
                            onChange={(e:any) => this.updateFAQQuestion(e, index)}
                            // error={isPublishBtnClicked && FAQ[index] !== '' ? true : false}
                            // errorText={FAQ[index]}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={[classes.labelTxt, classes.mb8].join(' ')}>
                            Answer
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.customTextArea}>
                        <MyPATTextArea
                            inputId="description"
                            name="description"
                            value={this.props.faq.FAQ[index].answer}
                            onChange={(e:any) => this.updateFAQAnswer(e, index)}
                            multiline
                            fullWidthControl
                            placeholder="Enter Answer"
                            disabled={disableFields || isPreview}
                            // error={isPublishBtnClicked && AnswerErrors[index] !== '' ? true : false}
                            // errorText={ AnswerErrors[index] }
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
      </Grid>
    </Grid>
    </>
    )
  }

  // renderFAQCards = () => {
  //   const FAQCards = this.state.faq.FAQ.map((faq, index) => this.renderCard(faq, index))
  //   this.setState({
  //       faqCards: FAQCards
  //   })
  // }

  handleAddFAQ = () => {
    let newFAQ = {
      question: '',
      answer: ''
    };
    let FAQError = ''
    let AnswerError = ''
    const { faq, faq : { FAQ = [] } } = this.props;
    let updatedFaq = {...faq}
    let updatedFAQ = [...FAQ]
    updatedFAQ.push(newFAQ);
    updatedFaq.FAQ = updatedFAQ;
    this.props.handleFAQ(updatedFaq);

    
    const updatedFormErrors = {...this.state.formErrors}
    const updatedFAQErrors = [...updatedFormErrors.FAQ, FAQError]
    const updatedAnsErrors = [...updatedFormErrors.AnswerErrors, AnswerError]
    updatedFormErrors.FAQ = updatedFAQErrors;
    updatedFormErrors.AnswerErrors = updatedAnsErrors;

    this.setState({
        formErrors: updatedFormErrors
    }, () => console.log(':::::::::FAQ Errors:::::::::',this.state.formErrors))
  }

  handleRemoveFAQ = (index: any) => {
    console.log(this.state.formErrors);
    const { faq, faq: {FAQ} } = this.props;
    let updatedFaq = {...faq};
    let updatedFAQ = [...FAQ];
    const removedFAQ = updatedFAQ.splice(index, 1);
    updatedFAQ = updatedFAQ.filter((faq) => faq !== removedFAQ[0])

    updatedFaq.FAQ = updatedFAQ;
    this.props.handleFAQ(updatedFaq);

    const updatedFormErrors = {...this.state.formErrors} // TODO: Getting empty errors
    console.log(updatedFormErrors)
    const updatedFAQErrors = [...updatedFormErrors.FAQ].filter((FAQError, idx) => idx !== +index) 
    const updatedAnsErrors = [...updatedFormErrors.AnswerErrors].filter((AnsError, idx) => idx !== +index)
    updatedFormErrors.FAQ = updatedFAQErrors;
    updatedFormErrors.AnswerErrors = updatedAnsErrors;

    console.log(updatedFormErrors)
    this.setState({
        formErrors: updatedFormErrors
    }, () => console.log(':::::::::FAQ Errors:::::::::',this.state.formErrors))
  }

  readExcel = (file:any) => {
    const promise = new Promise((resolve:any, reject:any) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e:any) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, {type:'buffer'});

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);

        fileReader.onerror=((error)=>{
          reject(error)
        })
      }
    });

    promise.then((d) => {
      this.processRawFAQData(d);
    })
  }

  handleFileData = (data: any) => {
    console.log('Data From File', data);
    this.processRawFAQData(data)
  }

  validateFAQData = (data: any[]) => {
    return data.reduce((acc, row) => {
      return acc && row.hasOwnProperty('Question') && row.hasOwnProperty('Answer') && row.hasOwnProperty('Sequence No.')
    }, true)
  }

  processRawFAQData = (data:any) => {
    // console.log('Received Data::::::', data)
    if(!this.validateFAQData(data)) {
      return;
    }
    const processedData = data.map((data:any) => ({
      question: data.Question,
      answer: data.Answer,
      sequence: data['Sequence No.']||data.length
      })
    )
    processedData.sort((a:any,b:any)=>{
      return a.sequence-b.sequence;
    });

    // console.log('Processed Data', processedData)
    let {faq, faq:{FAQ}} = this.props;
    let updatedFaq = {...faq};
    console.log({FAQ});
    FAQ = FAQ.filter((faq)=>{return faq.question;});
    console.log({FAQ});
    let updatedFAQ = [...processedData,...FAQ];
    // console.log(updatedFAQ)
    // const {faqWithSequence, faqWithoutSequence} = this.sortFAQQuestions(updatedFAQ)
    updatedFaq.FAQ = updatedFAQ;
    this.props.handleFAQ(updatedFaq);
    this.props.showMessage('FAQ(s) Successfully Uploaded!', 'success')
  }

  sortFAQQuestions = (data: any) => {
    let faqWithSequence:any = [];
    let faqWithoutSequence:any = [];

    data.forEach((faq:any) => {
      if(faq.sequence){
        faqWithSequence.push(faq)
      } else {
        faqWithoutSequence.push(faq)
      }
    })
    // console.log('FAQ with sequence', faqWithSequence.sort(this.compare))
    // console.log('FAQ without sequence', faqWithoutSequence)
    return {faqWithSequence, faqWithoutSequence}
  }

   compare = ( a:any, b:any ) => {
    if ( +a.sequence < +b.sequence ){
      return -1;
    }
    if ( +a.sequence > +b.sequence ){
      return 1;
    }
    return 0;
  }

  render() {
    const { classes,disableFields,isPreview } = this.props;
    const { open } = this.state;
    console.log('open------->', open)
    return <>
    <Grid container spacing={8} justify="flex-end" alignItems="center" className={classes.mb18}>
      <Grid item>
       
          {/* {
            !disableFields &&
            <input type="file" id="file" 
            onChange={(e:any) => {
               const file = e.target.files[0];
               this.readExcel(file);
             }}
             />
          } */}
          {
            isPreview?(
              <span className={classes.customFileBrowse}>
              <label htmlFor="file" className={[isPreview? classes.disableCTA:classes.linkCTA, classes.mb18].join(' ')}>
              <img src="/assets/svg/myLibrary/uploadIcon.svg" />&nbsp; Upload File</label>
         </span>
            ):(
              <span className={classes.customFileBrowse}>
              <label  onClick={() => this.toggleUploadDialog()} htmlFor="file" className={[isPreview? classes.disableCTA:classes.linkCTA, classes.mb18].join(' ')}>
              <img src="/assets/svg/myLibrary/uploadIcon.svg"/>&nbsp; Upload File</label>
         </span>
            )
          }
          
        {/* <span>Upload File</span> */}
        {/* <input 
          type="file"
          onChange={(e:any) => {
            const file = e.target.files[0];
            this.readExcel(file);
          }}
        /> */}
      </Grid>
      <Grid item>
        {
          isPreview?(
            <span className={[classes.disableCTA, classes.mb18].join(' ')}>+ Add More FAQ</span>
           ):(
            <span onClick={() => this.handleAddFAQ()} className={[classes.linkCTA, classes.mb18].join(' ')}>+ Add More FAQ</span>
           )
        }
          </Grid>
    </Grid>
    {this.props.faq.FAQ.map((faq, index) => this.renderCard(faq, index))}

      {open && <UploadFAQPopUp 
        open={open}
        onClose={this.toggleUploadDialog}
        onDone={this.handleFileData}
      />}
    </>;
  }
}

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showMessage: showMsg,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
   // @ts-ignore
)(withStyles(courseStyles)(FAQ));
